import { Component, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';

@Component({
  selector: 'app-filter-path',
  template: '<ng-template></ng-template>'
})
export class FilterPathComponent extends ComponentBase implements OnInit {

  constructor() { 
    super() 
  }

  ngOnInit() {
  }

}
